import React, { useState } from "react";
import { Modal, Table, Button, Alert } from "react-bootstrap";
import { useSetChangeHead } from "../../API_Master/MutateAPI";
import { notifyError, notifySuccess } from "../../MethodMaster/JSXComponentMothod";
import Loader from "../../CommonComponents/Loader";
import Cookies from "js-cookie";

const ChangeHeadModal = ({ show, data, handleClose, familyHeadMasterID, refetch, headData, statusType, deadNonVoterHeadID }) => {
  console.log("sdfljsldfjsalfkjdsakfjdasf", data);
  const [selectedHead, setSelectedHead] = useState(null);
  const { mutate: addChangeHead, isPending: inserting } = useSetChangeHead();

  const onSubmit = () => {
    if (selectedHead) {
      let newHeadData = data?.FamilyMemberDetails?.find((item) => item.VoterID === selectedHead);
      newHeadData = { ...newHeadData, IsHead: true };

      const payload = {
        UserID: Cookies.get("Mukesh_Patel_UserID"),
        FamilyHeadMasterID: familyHeadMasterID || "",
        ContactDetailID: deadNonVoterHeadID || "",
        StatusType: statusType,
        Death: statusType?.trim() ? (statusType?.toLowerCase() === "death" ? true : false) : null,
        NotVoter: statusType?.trim() ? (statusType?.toLowerCase() === "notvoter" ? true : false) : null,
        // FamilyDetail: [newHeadData, headData, ...data?.FamilyMemberDetails?.filter((item) => item.VoterID !== selectedHead).map((item) => ({ ...item, IsHead: false }))],
        FamilyDetail: [
          ...(statusType?.toLowerCase() === "death" || statusType?.toLowerCase() === "notvoter" ? [] : [headData]),
          newHeadData,
          ...(data?.FamilyMemberDetails?.filter((item) => item.VoterID !== selectedHead).map((item) => ({ ...item, IsHead: false })) || []),
        ],
      };

      console.log("payloadpayload", payload);

      addChangeHead(payload, {
        onSuccess: (res) => {
          if (res?.status === true) {
            notifySuccess("Successfully Inserted", false);
            handleClose();
            refetch();
          } else {
            notifyError(res?.message ? res.message : "Data Not Inserted", false);
          }
        },
        onError: (err) => {
          const errorMessage = err?.message || "Failed to assign system";
          console.error(err);
          notifyError(errorMessage || "Something went wrong", false);
        },
      });
    } else {
      notifyError("Please Select Head first to submit");
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} dialogClassName="custom-modal-width" size="lg" centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {!selectedHead && data?.members?.length > 0 && (
            <Alert variant="warning" className="mb-3">
              Please select a head to Submit.
            </Alert>
          )}

          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Mobile No</th>
                <th>Gender</th>
                <th>Age</th>
                <th>Head</th>
              </tr>
            </thead>
            <tbody>
              {data?.FamilyMemberDetails?.length > 0 ? (
                data.FamilyMemberDetails.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.FullNameEnglish}</td>
                    <td>{row.MobileNo}</td>
                    <td>{row.Gender?.toLowerCase() === "f" ? "Female" : row?.Gender?.toLowerCase() === "m" ? "Male" : ""}</td>
                    <td>{row.Age}</td>
                    <td>
                      <input
                        className="head-Radio"
                        type="radio"
                        name="head"
                        value={row?.VoterID}
                        checked={selectedHead === row?.VoterID}
                        onChange={() => setSelectedHead(row?.VoterID)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>

        {/* <Modal.Footer className="d-flex align-items-center justify-content-between w-100">
          <div style={{ fontSize: "0.9rem", color: "#c91a1aff", fontStyle: "italic" }}>Please select a head to proceed.</div>
          <div className="gap-3">
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onSubmit} disabled={!selectedHead}>
              Submit
            </Button>
          </div>
        </Modal.Footer> */}
        <Modal.Footer className="d-flex align-items-center justify-content-between w-100">
          {/* Note Card */}
          <div
            style={{
              // padding: "6px 12px",
              // backgroundColor: "#ffe6e6", // light red/pink for warning
              // borderRadius: "6px",
              // boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              // fontSize: "0.9rem",
              color: "red", // dark red
              fontStyle: "italic",
            }}
          >
            Please select a head to proceed.
          </div>

          {/* Buttons */}
          <div className="d-flex gap-2">
            {/* <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button> */}
            <Button variant="primary" onClick={onSubmit} disabled={!selectedHead}>
              Submit
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      {inserting && <Loader />}
    </>
  );
};

export default ChangeHeadModal;
